/* BROKENWING — minimal reveal-on-scroll.
   rAF-throttled scroll/resize check, reveals each element once, then removes
   its own listeners when done. Only hides elements that are off-screen on load
   (no flash, nothing left hidden if this never runs). Skips reduced-motion. */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SEL = '.bw-sec-head, .bw-card, .bw-tile, .bw-ugc__item, .bw-trust__item, .bw-rv-card, .bw-reviews__head, .bw-story, .bw-news__inner';
  var pending = [];
  var ticking = false;

  function revealEl(el) {
    var parent = el.parentElement;
    if (parent) {
      var sibs = parent.querySelectorAll(':scope > .bw-reveal');
      var idx = Array.prototype.indexOf.call(sibs, el);
      if (idx > 0) el.style.transitionDelay = Math.min(idx, 5) * 70 + 'ms';
    }
    el.classList.add('is-in');
  }

  function check() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    for (var i = pending.length - 1; i >= 0; i--) {
      if (pending[i].getBoundingClientRect().top < vh * 0.92) {
        revealEl(pending[i]);
        pending.splice(i, 1);
      }
    }
    if (!pending.length) {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; check(); });
  }

  function init() {
    var els = document.querySelectorAll(SEL);
    if (!els.length) return;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    els.forEach(function (el) {
      if (el.getBoundingClientRect().top < vh * 0.95) return; // in view on load — leave visible
      el.classList.add('bw-reveal');
      pending.push(el);
    });
    if (!pending.length) return;
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
